export default __webpack_public_path__ + "static/media/goodleapLogo.4a70c67e.jpg";